var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, MessageBanner } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { generateVolumeRecordsForLibrary } from "../../api/periodicalIssueService";
import { invalidateVolumeViews } from "../../hooks/usePeriodicalVolumes";
import { extractServerErrorMessage } from "../../utils/errorHandler";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
import { describeVolume } from "../../utils/volumeWindow";
import css from "./VolumeLibraryRecordsOffer.module.css";
export var VolumeLibraryRecordsOffer = function (_a) {
    var periodicalLibraryId = _a.periodicalLibraryId, volume = _a.volume;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _b = useState(null), errorMessage = _b[0], setErrorMessage = _b[1];
    var mutation = useMutation(function (volumeId) {
        return generateVolumeRecordsForLibrary(kyInstance, periodicalLibraryId, volumeId);
    }, {
        onSuccess: function () {
            setErrorMessage(null);
            invalidateVolumeViews(queryClient);
            invalidateDepositRecordViews(queryClient);
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = setErrorMessage;
                        return [4 /*yield*/, extractServerErrorMessage(error, formatMessage, formatMessage({
                                id: "ui-br-legaldeposits.periodicals.volume.libraryRecords.error",
                            }))];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        }); },
    });
    var handleGenerate = useCallback(function () {
        setErrorMessage(null);
        mutation.mutate(volume.id);
    }, [mutation, volume.id]);
    return (React.createElement("div", { className: css.offer },
        React.createElement(MessageBanner, { type: "warning" }, formatMessage({
            id: "ui-br-legaldeposits.periodicals.volume.libraryRecords.missing",
        }, { volume: describeVolume(volume) })),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, onClick: handleGenerate, disabled: mutation.isLoading }, formatMessage({
            id: "ui-br-legaldeposits.periodicals.volume.libraryRecords.generate",
        })),
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage))));
};
